import { FieldRequirement } from "../components/FieldRequirement";
import { useEffect, useState } from "react";
import { request } from "../api/client";
import { AppSelect } from "../components/inputs/AppSelect";
import { useLocale } from "../i18n";
import type { ServicePrice } from "./ProductManagement";
import { billingTermLabel } from "./billingQuotes";

export function PromotionPlanSelect({productId,value,onChange,currentLabel}:{productId:string;value:string;onChange:(value:string)=>void;currentLabel?:string}) {
  const {w}=useLocale();
  const [plans,setPlans]=useState<ServicePrice[]>([]);
  const [loading,setLoading]=useState(true);
  const [failed,setFailed]=useState(false);
  const [revision,setRevision]=useState(0);
  useEffect(()=>{
    const controller=new AbortController();setLoading(true);setFailed(false);
    async function load(){
      const all:ServicePrice[]=[];let cursor:string|null=null;
      do {
        const query=new URLSearchParams({productId});if(cursor)query.set("cursor",cursor);
        const page=await request<{items:ServicePrice[];nextCursor:string|null}>("/productPrices?"+query,"GET",undefined,controller.signal);
        all.push(...page.items);cursor=page.nextCursor;
        if(all.length>200 || (cursor && all.length>=200))throw new Error("Plan list exceeds supported size");
      }while(cursor && !controller.signal.aborted);
      if(!controller.signal.aborted)setPlans(all);
    }
    void load().catch(()=>{if(!controller.signal.aborted)setFailed(true);}).finally(()=>{if(!controller.signal.aborted)setLoading(false);});
    return ()=>controller.abort();
  },[productId,revision]);
  return <div className="price-wide"><label><span className="field-caption">{w("باقة الاشتراك","Subscription plan")}
    <FieldRequirement required={true} /></span><AppSelect aria-label={w("باقة الاشتراك","Subscription plan")} value={value} onChange={onChange} required disabled={loading||failed}>
      <option value="">{loading?w("جارٍ تحميل الباقات…","Loading plans…"):w("اختر الباقة التي يقبلها الكود","Select the plan for this code")}</option>
      {value&&!plans.some(p=>(p.priceSeriesId||p.priceId)===value)&&<option value={value} disabled>{currentLabel||w("الباقة السابقة غير متاحة","Previous plan unavailable")}</option>}
      {plans.map(p=><option key={p.priceId} value={p.priceSeriesId||p.priceId}>{p.label} · {billingTermLabel({periodUnit:p.periodUnit as "DAY"|"WEEK"|"MONTH"|"YEAR",periodCount:p.periodCount},w)} · {p.amount} {p.currency}{p.state!=="ACTIVE"?` · ${w("غير معتمدة","Inactive")}`:""}</option>)}
    </AppSelect></label>
    {failed?<p role="alert">{w("تعذر تحميل الباقات.","Could not load plans.")} <button type="button" className="secondary" onClick={()=>setRevision(n=>n+1)}>{w("إعادة المحاولة","Retry")}</button></p>:<p className="product-price-caption">{w("لا يُقبل الكود لأي باقة أو مدة أخرى. تعديل سعر هذه الباقة يحافظ على ارتباط الكود بها.","The code cannot apply to another plan or duration. Repricing this plan preserves the code's link to it.")}</p>}
  </div>;
}
